// Design Tokens - Sistema de Design EGE Soluções Industriais
export const designTokens = {
  // Paleta de Cores Principal (baseada na identidade EGE)
  colors: {
    // Cores Primárias EGE
    primary: {
      blue: '#0476D9',        // Azul principal EGE
      blueLight: '#4A9EFF',   // Azul claro para hover/active
      blueDark: '#034A8B',    // Azul escuro para variações
    },
    
    // Cores Neutras (Fundos e Textos)
    neutral: {
      background: '#1a1a1a',      // Fundo principal (mais escuro)
      backgroundCard: '#2a2a2a',   // Fundo dos cards
      backgroundHover: '#3a3a3a',  // Hover state
      border: 'rgba(255, 255, 255, 0.1)', // Bordas sutis
      borderAccent: 'rgba(4, 118, 217, 0.3)', // Bordas com accent
    },
    
    // Cores de Texto
    text: {
      primary: '#ffffff',         // Texto principal
      secondary: '#ccccccff',       // Texto secundário
      muted: '#a0a0a0ff',           // Texto menos importante
      accent: '#0476D9',          // Texto de destaque
    },
    
    // Cores de Status (uso sutil e específico)
    status: {
      success: '#4CAF50',        // verde
      warning: '#E0CB0F',        // amarelo/alaranjado (6 dígitos)
      info:    '#2196F3',
      error:   '#F44336',
      neutral: '#9E9E9E',
    },
    
    // Gradientes sutis
    gradients: {
      background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
      card:       'linear-gradient(145deg, #2a2a2a 0%, #323232 100%)',
      accent:     'linear-gradient(135deg, #0476D9 0%, #4A9EFF 100%)',
    }
  },
  
  // Tipografia
  typography: {
    fontFamily: {
      primary: "'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      mono: "'Roboto Mono', 'Courier New', monospace",
    },
    
    fontSize: {
      xs: '14px',
      sm: '16px',
      base: '18px',
      lg: '20px',
      xl: '22px',
      '2xl': '24px',
      '3xl': '32px',
      '4xl': '48px',
      '5xl': '64px',
    },
    
    fontWeight: {
      light: 300,
      regular: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    
    lineHeight: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.7,
    }
  },
  
  // Espaçamento
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    '2xl': '24px',
    '3xl': '32px',
    '4xl': '48px',
  },
  
  // Bordas e Raios
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '50%',
  },
  
  // Sombras
  shadows: {
    sm: '0 2px 4px rgba(0, 0, 0, 0.1)',
    md: '0 4px 8px rgba(0, 0, 0, 0.15)',
    lg: '0 8px 16px rgba(0, 0, 0, 0.2)',
    xl: '0 12px 24px rgba(0, 0, 0, 0.25)',
    accent: '0 0 20px rgba(4, 118, 217, 0.3)',
  },
  
  // Transições
  transitions: {
    fast: '0.15s ease',
    normal: '0.3s ease',
    slow: '0.5s ease',
  },
  
  // Breakpoints para responsividade
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    '2xl': '1536px',
  },
  
  // Z-index layers
  zIndex: {
    base: 0,
    overlay: 100,
    modal: 200,
    notification: 300,
    tooltip: 400,
  }
}

// Helpers para uso fácil
export const { colors, typography, spacing, borderRadius, shadows, transitions } = designTokens
